import Confetti from 'react-confetti';

import React from 'react';

const Confettis = () => {
  return <Confetti width={window.innerWidth} height={window.innerHeight} />;
};

export default Confettis;
